import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class PolicyDiffService {
    static getPolicyDiffWithPrevious(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policydiff'), 'getPolicyDiffWithPrevious', [data], additionalHeaders);
    }

    static getDiffToPrevious(jobNumber, policyNumber, additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewaypolicydiff'), 'getDiffToPrevious', [jobNumber, policyNumber], additionalHeaders);
    }
}
